import { Switch } from 'module/ui/components/atoms/switch/switch';
import { useParams } from '@rocketlane/rocket-router';
import { tv } from 'tailwind-variants';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { useAutomationContext } from './create/automation-context';
import { AutomationContactBlock } from './create/blocks/automation-contact-block';
import { AutomationContactEditBlock } from './edit/blocks/automation-contact-edit-block';

const automationContactVariants = tv({
  slots: {
    toggleSection: 'flex gap-2 items-start',
    description: 'font-normal text-[12px] leading-4 text-[#525252] flex-1',
  },
});

export type AutomationContactProps = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export const AutomationContact = ({
  checked: _checked = false,
  onChange,
  disabled = false,
}: AutomationContactProps) => {
  const { integrationId, automationId } = useParams<{
    integrationId: string;
    automationId: string;
  }>();

  const isEditMode = !!automationId && !!integrationId;

  const {
    automationDetails,
    isContactSelected,
    setIsContactSelected,
    setAutomationDetails,
  } = useAutomationContext();

  const { description } = automationContactVariants();
  const { salesForceType: automationSalesForceType } = automationDetails || {};

  const handleToggle = (newValue: boolean) => {
    onChange?.(newValue);
    setIsContactSelected(newValue);

    // Clear contact-related fields when toggle is turned OFF
    if (!newValue) {
      setAutomationDetails({
        contactFields: undefined,
        sourceResourceType: undefined,
        sourceRelationshipName: undefined,
        sourceParentResourceId: undefined,
        sourceParentResourceType: undefined,
      });
    }
  };

  return (
    <>
      <BlockList.Item actionIcon={false}>
        <div className="flex flex-col flex-1">
          <BlockList.Item.Label>
            <BlockList.Item.Label.Text>Contacts</BlockList.Item.Label.Text>
          </BlockList.Item.Label>

          <div className="flex flex-row gap-2 px-6 pb-2">
            <Switch
              checked={isContactSelected}
              onChange={handleToggle}
              disabled={disabled}
              size="small"
            />

            <p className={description()}>
              Also pull contacts from this account
            </p>
          </div>
          {isContactSelected && automationSalesForceType && (
            <div className="mt-2">
              {isEditMode ? (
                <AutomationContactEditBlock
                  isContactSelected={isContactSelected}
                />
              ) : (
                <AutomationContactBlock isContactSelected={isContactSelected} />
              )}
            </div>
          )}
        </div>
      </BlockList.Item>
    </>
  );
};
